export const normalizeIntercomEventName = (eventName: string): string => {
  return (eventName ?? '').toLowerCase().replace(/ /g, '-');
};
